<template>
    <div class="flow-line-container">
        <div :id="id" class="flow-line"></div>
    </div>
</template>


<script>
  // import { List } from 'ant-design-vue'

  export default {
    props: {
      data: Array,
      id: String
    },
    data() {
      return {
        myChart: null
      }
    },

    mounted() {
      setTimeout(() => {
        this.drawCounty()
      }, 10)
    },

    methods: {
      drawCounty() {
        // 基于准备好的dom，初始化echarts实例
        let allCount = 0
        this.data.forEach(item => {
          allCount += item.value
        })
        this.myChart = this.$echarts.init(document.getElementById(this.id))
        // 绘制图表
        this.myChart.setOption({
          tooltip: {
            trigger: 'item'
          },
          grid: {
            right: '1%',
            top: '5%',
            left: '5%',
            bottom: '15%'
          },
          legend: {
            orient: 'vertical',
            right: '10%',
            top: '20%',
            itemHeight: 12,
            itemWidth: 12,
            itemGap: 20,
            formatter:
              (name) => {
              for(let i = 0; i< this.data.length; i++) {
                if(name === this.data[i].name) {
                  return `${name}  ${(this.data[i].value / allCount * 100).toFixed(2)} %`
                }
              }
            }
          },
          color: ['#7192FF', '#83DB83', '#FAE076', '#64E9E9','#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
          series: [
            {
              type: 'pie',
              radius: '70%',
              center: ['35%', '50%'],
              data: this.data,
              label: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 4
              },
              // emphasis: {
              //   itemStyle: {
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: 'rgba(0, 0, 0, 0.5)'
              //   }
              // }
            }
          ]
        })
        window.addEventListener('resize', () => {
          this.myChart.resize()
        })
      }
    },
    watch: {
      data() {
        this.drawCounty()
      }
    }
  }
</script>


<style lang="less" scoped>
    .flow-line-container {
        width: 100%;
        height: 300px;

        .flow-line {
            height: 100%;
        }

        .head {
            height: 40px;
            display: flex;
            align-items: flex-start;
            border-bottom: 1px solid #ebebeb;
            margin-bottom: 10px;

            .title {
                color: #333333;
                font-weight: 600;
                font-size: 18px;
            }
        }
    }
</style>
